import React, { useMemo, useState,useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../../components/header/Header";
import CourseTable from "../../components/table/CourseTable";
import TablePagination from "../../components/table/TablePagination";
import BackendTableSearch from "../../components/table/BackendTableSearch";
import { useQuery } from "react-query";
import { endpoint } from "../../API/config";
import { apirequest } from "../../API/api";
import Loader from "../../components/global/loader/Loader";
import { useSelector,useDispatch } from "react-redux";
import {getHeaderDetail,getSubheaderOption,getCurrentSubHeaderTab} from "../../redux/features/header/headerSlice";

const AccessManagement = () => {

  const login_Details = useSelector(state=>state?.loginData?.LoginDetails);

  const dispatch = useDispatch();
  const column = [
    { col: "0", width: "45%" },
    { col: "1", width: "50%" },
    { col: "2", width: "" },
  ];
  const {
    data: user_Data,
    status,
    error,
  } = useQuery(endpoint.access_Management_User_Api.key, 
    () => apirequest({
      url: `${endpoint.access_Management_User_Api.addr}`,
      method: "POST",
      data: {
        adminImsPin: login_Details.userImsPin,
      },
    }),
    {
      select: (data) => data.data.data,
    }
  );

  const [currentPage, setCurrentPage] = useState(1);
  const [searchValue, setSearchValue] = useState("");
  const dataPerPage = 5;
  const indexOfLastItem = currentPage * dataPerPage;
  const indexOfFirstItem = indexOfLastItem - dataPerPage;
  const paginate = pageNumbers => {
    setCurrentPage(pageNumbers);
  };

  const allUsers = user_Data?.usersList ?? [];
  const normalizedSearch = searchValue.trim().toLowerCase();
  const searchTokens =
    normalizedSearch.length > 0 ? normalizedSearch.split(/\s+/) : [];

  const filteredUsers = useMemo(() => {
    if (searchTokens.length === 0) {
      return allUsers;
    }

    return allUsers.filter((user) => {
      const name = String(user?.userName ?? "").toLowerCase();
      const imsId = String(user?.userImspin ?? "").toLowerCase();
      return searchTokens.some(
        (token) => name.includes(token) || imsId.includes(token)
      );
    });
  }, [allUsers, searchTokens]);

  useEffect(() => {
    dispatch(getCurrentSubHeaderTab(""));
    dispatch(getHeaderDetail(""));
    dispatch(getSubheaderOption(""));
  }, []);

  if (status === "loading") {
    return (
      <div>
        <Header />
        <Loader />
      </div>
    );
  }

  if (status === "error") {
    return (
      <div>
        <Header />
        <span>{error.message}</span>
      </div>
    );
  }

  return (
    <div>
      <Header />
      <div className=" m-9">
        <div className="flex justify-between">
          <span className="text-base font-medium ">Access Management</span>
          <div className="flex items-center">
            <BackendTableSearch
              placeholder="Search by Name / IMS ID"
              searchValue={searchValue}
              setSearchValue={setSearchValue}
              setCurrentPage={setCurrentPage}
            />
            {user_Data.global_add_access === "1" ? (
              <Link to="/access_Management/Add-User">
                <button className="px-10 py-3 bg-primary-300 text-white rounded-2xl shadow-outer  ml-6">
                  Add User
                </button>
              </Link>
            ) : null}
          </div>
        </div>
        <div className=" shadow-outer rounded-2xl pb-2 mt-5">
          <CourseTable
            column={column}
            currentData={filteredUsers.slice(
              indexOfFirstItem,
              indexOfLastItem,
            )}
            tableHead={false}
          />
        </div>
        <TablePagination
          data={filteredUsers}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          paginate={paginate}
          dataPerPage={dataPerPage}
        />
      </div>
    </div>
  );
};
export default AccessManagement;
